var _path, _circle, _ellipse, _path2, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNorneSoyleIkon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 200 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2a2a2a",
  d: "M193.82 189.5H2.27v-3h191.55a2.41 2.41 0 0 0 2.41-2.41V9.92h3v174.17a5.42 5.42 0 0 1-5.41 5.41"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 169.19,
  cy: 60.4,
  r: 6.84,
  fill: "#2a2a2a"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 99.81,
  cy: 127.83,
  fill: "#2a2a2a",
  rx: 7.04,
  ry: 6.84
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2a2a2a",
  d: "M24.73 91.67h2V188h-2zM99 126.78h2V188h-2zM168.34 59.35h2V188h-2z"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 25.73,
  cy: 92,
  fill: "#2a2a2a",
  rx: 7.04,
  ry: 6.84
})));
export default SvgNorneSoyleIkon;